<!--
  PBA Index View Template Component Picker
  Different designs
-->

<template>
  <div style="min-height: 100vh;">
    <component :is="(website_data.profile.template_name || 'LSBD') + 'View'" />
  </div>
</template>

<script>
  export default {
    components: {
      LSBDView: () => import('@/views/LSBD/Index'),
      BBRCView: () => import('@/views/BBRC/Index'),
      DARAView: () => import('@/views/DARA/Index'),
      OCEANView: () => import('@/views/OCEAN/Index'),
      // Future templates here
    },
  }
</script>
